import { Stack } from '@mui/material';
import { RouterProvider } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';

import { Auth0Wrapper, useAuth0Context } from './auth/auth0';
import { LoadingSpinner } from './components/LoadingSpinner';
import { useLargeType } from './hooks/useLargeType';
import { router } from './router';

function InnerApp() {
    const auth = useAuth0Context();
    // Initialize large type preference from localStorage and apply CSS
    useLargeType();

    if (auth.isLoading) {
        return (
            <Stack sx={{ justifyContent: 'center', alignItems: 'center', minHeight: '100dvh' }}>
                <LoadingSpinner />
            </Stack>
        );
    }

    return (
        <>
            <RouterProvider router={router} context={{ auth }} />
            {import.meta.env.DEV && <TanStackRouterDevtools router={router} />}
        </>
    );
}

function App() {
    return (
        <Auth0Wrapper>
            <InnerApp />
        </Auth0Wrapper>
    );
}

export default App;
